module.exports = __webpack_public_path__ + "static/media/cx.58e3aae7.svg";